
import { defineComponent, computed } from 'vue'
import { FormDataStructure } from '@/contracts/forms/FieldContracts'
import { NuxeoUpdateUserResponse } from '@/contracts/api/ResponseContracts'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Heading from '@/components/Heading.vue'
import Form from '@/components/Form.vue'
import { axiosPostAccountUpdate } from '@/composables/api'

export default defineComponent(
{
    name: 'AccountUpdatePassword',
    components:
    {
        Heading,
        Form
    },
    setup()
    {
        // Load router:
        const router = useRouter()
        // Load vuex:
        const store = useStore()

        // Computed state params:
        const authenticatedUser = computed(() =>
        {
            return store.getters['auth/getUser']
        })

        // Set password fields:
        const fields =
        {
            password:
            {
                name: 'password',
                type: 'Input',
                label: 'Password',
                hint: 'Password must contain at least one lowercase letter, one uppercase letter, one special character, at least one digit and a minimum of 8 characters long.',
                inputType: 'password',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    },
                    password:
                    {
                        config: true
                    }
                }
            },
            passwordconfirm:
            {
                name: 'passwordconfirm',
                type: 'Input',
                label: 'Confirm password',
                hint: 'Please confirm your password',
                inputType: 'password',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    },
                    confirm:
                    {
                        config: 'password'
                    }
                }
            }
        }
        // Set password buttons:
        const buttons =
        {
            submit:
            {
                name: 'submit',
                type: 'Submit',
                text: 'Create a new password'
            }
        }
        // Handle password submission. The target user is the signed-in caller,
        // pinned server-side from the Bearer token (never sent from here).
        const saveFormData = (formData: FormDataStructure) =>
        {
            axiosPostAccountUpdate(
            {
                password: formData.password
            },
            function(response: NuxeoUpdateUserResponse)
            {
                store.commit('confirmations/setConfirmationData',
                {
                    title: 'New password created',
                    body: 'Your password has been updated'
                })
                router.push({ hash: '#confirmation-summary-container' })
            })
        }

        // Return data:
        return {
            authenticatedUser,
            fields,
            buttons,
            saveFormData
        }
    }
})
